<template>
  <div class="form-line form-phone" :class="{'-top': value || inputFocus || autofill || type === 'date', '-error': validations.find( o => o.condition )}">
    <div class="form-select">
      <label :for="'select-' + id" :aria-label="$t('Area code')"><i class="icon-fleche"></i></label>
      <select
        :id="'select-' + id"
        :name="'select-' + name"
        :required="required ? true : false"
        :aria-required="required ? true : false"
        @change="$emit('phoneIndic', $event.target.value)" autocomplete="tel-country-code"
        :aria-invalid="validations.find( o => o.condition ) ? (phoneInfos.code ? false : true) : false"
        :aria-describedby="validations.find( o => o.condition ) ? 'error-' + id : false"
      >
        <option disabled selected value v-if="!phoneInfos.code" />
        <option v-for="(option, key) in phoneExtension" :key="key" :value="option.value" v-bind="{ selected: option.value === phoneInfos.code }" >{{ option.label }}</option>
      </select>
      <div v-text="phoneInfos.code"></div>
    </div>
    <label :for="id">{{ placeholder }}</label>
    <input
      :id="id"
      :ref="name"
      :type="type"
      :name="name"
      :value="phoneInfos.phone"
      @blur="blur()"
      :autofocus="autofocus"
      @focus="inputFocus = true"
      :autocomplete="autocomplete"
      :required="required ? true : false"
      :aria-required="required ? true : false"
      :aria-invalid="validations.find( o => o.condition ) ? (phoneInfos.phone ? false : true) : false"
      :aria-describedby="validations.find( o => o.condition ) ? 'error-' + id : false"
      @keyup="$emit('keyup', $event)"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="$emit('keyup.enter', $event.target.value)"
      @keydown="checkDigit"
    />
    <ValidationMessages v-if="validations" :validations="validations" :id="id" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'
import { parsePhoneNumber } from '../../utilities'
let phoneExtension = () => import('../../resource/json/phone-extension.json').then(module => module.default)

export default {
  name: 'BasePhone',
  components: {
    ValidationMessages
  },
  computed: {
    phoneInfos () {
      const parsedPhoneNumber = parsePhoneNumber(
        this.value,
        this.phoneIndic,
        this.phoneExtensionCode
      )
      if (parsedPhoneNumber.code) {
        this.$emit('phoneIndic', parsedPhoneNumber.code)
      }
      if (parsedPhoneNumber.phone) {
        this.$emit('input', parsedPhoneNumber.phone)
      }
      return parsedPhoneNumber
    }
  },
  data() {
    return {
      inputFocus: false,
      autofill: false,
      phoneExtension: [],
      phoneExtensionCode: []
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    phoneIndic: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    changeCode(e) {
      this.$emit('phoneIndic', e.target.value)
    },
    setFocus(fieldName) {
      if (this.name === fieldName) {
        this.$refs[this.name].focus()
      }
    },
    blur() {
      this.inputFocus = false
      this.$emit('blur')
    },
    checkDigit(e) {
      if (e.key.length === 1 && isNaN(Number(e.key))) {
        e.preventDefault()
      }
    }
  },
  mounted() {
    phoneExtension()
      .then((data) => {
        const datasorted = data.sort((a,b) => a.label > b.label ? 1 : -1)
        this.phoneExtension = datasorted
        this.phoneExtensionCode = datasorted.map(({ value }) => value)
      })
    if (this.focus) {
      this.$refs[this.name].focus()
    }

    try {
      if (this.$el.querySelector('input:-webkit-autofill')) {
        this.autofill = true
      }
    } catch (e) {}
  }
}
</script>
